import { type PaginatedCase, type PaginatedTransformedCase } from "@/api/resources/cases/types";
import { filterNotEmpty } from "@/utils/format";

export const transformPaginatedCases = (_cases: PaginatedCase[]): PaginatedTransformedCase[] => {
  return _cases.filter(filterNotEmpty).map((caseItem) => {
    const attachmentDevice = Boolean(caseItem.device_id);
    const attachmentParts = caseItem.parts && caseItem.parts.length > 0 ? caseItem.parts.length : undefined;

    return {
      ...caseItem,
      attachmentDevice,
      attachmentParts,
    };
  });
};
